import React, {useMemo} from 'react';
import Box from '@mui/material/Box';
import KeyFeatureContainer, {
  IKeyFeatureContainer,
} from '@wearesection/bandai-react-components/organisms/KeyFeatureContainer';
import {KeyFeature, MediaGallery, NewsContent} from '~/graphql/types';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
// import {getOptions} from './body-rich-text-renderer-options';
import {PLACEHOLDER_IMG} from '~/constants';
import {GetRouter, titleLowerCase} from '~/utils';
import RenderNextImage from '../../atoms/render-next-image';
import {getOptions} from '../body-article/body-rich-text-renderer-options';

type IKeyFeatureContainerExt = IKeyFeatureContainer &
  MediaGallery & {
    dataComplexKeyFeatureCard: MediaGallery;
    dataKeyFeatureCard: KeyFeature[];
  };

const adapter = (data: any) => {
  const {onlyShowKeyFeatureCard, dataComplexKeyFeatureCard, dataKeyFeatureCard, locale} = data;
  return {
    title: titleLowerCase(data?.title || '') ?? '',
    onlyShowKeyFeatureCard: onlyShowKeyFeatureCard,
    dataComplexKeyFeatureCard:
      (dataComplexKeyFeatureCard && {
        titleMobile: data?.title ?? '',
        titleContent: dataComplexKeyFeatureCard?.title ?? '',
        descriptionTop:
          dataComplexKeyFeatureCard?.description ??
          documentToReactComponents(
            dataComplexKeyFeatureCard?.description?.json,
            getOptions(dataComplexKeyFeatureCard?.description as NewsContent)
          ),
        descriptionBottom: '',
        imgCenter: {
          href: dataComplexKeyFeatureCard?.mainFeaturedImage?.media?.url ?? PLACEHOLDER_IMG,
          alt: dataComplexKeyFeatureCard?.items?.[2]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={dataComplexKeyFeatureCard?.mainFeaturedImage?.media?.url ?? PLACEHOLDER_IMG}
              layout="responsive"
            />
          ),
        },
        imgLeftTop: {
          href:
            dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[0]?.media?.url ??
            PLACEHOLDER_IMG,
          alt: dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[0]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[0]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={466}
              height={500}
            />
          ),
        },
        imgLeftCenter1: {
          href:
            dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[1]?.media?.url ??
            PLACEHOLDER_IMG,
          alt: dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[1]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[1]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={250}
              height={250}
            />
          ),
        },
        imgLeftCenter2: {
          href:
            dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[2]?.media?.url ??
            PLACEHOLDER_IMG,
          alt: dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[2]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[2]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={250}
              height={250}
            />
          ),
        },
        imgLeftBottom: {
          href: dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[3]?.media
            ?.url,
          alt: dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[3]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.leftColumnFeaturedImagesCollection?.items?.[3]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={466}
              height={500}
            />
          ),
        },
        imgRightTop1: {
          href:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[0]?.media
              ?.url ?? PLACEHOLDER_IMG,
          alt:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[0]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[0]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={250}
              height={250}
            />
          ),
        },
        imgRightTop2: {
          href:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[1]?.media
              ?.url ?? PLACEHOLDER_IMG,
          alt:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[1]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[1]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={250}
              height={250}
            />
          ),
        },
        imgRightCenter: {
          href:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[2]?.media
              ?.url ?? PLACEHOLDER_IMG,
          alt:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[2]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[2]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={466}
              height={500}
            />
          ),
        },
        imgRightBottom: {
          href:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[3]?.media
              ?.url ?? PLACEHOLDER_IMG,
          alt:
            dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[3]?.alt ?? '',
          nextImg: (
            <RenderNextImage
              src={
                dataComplexKeyFeatureCard?.rightColumnFeaturedImagesCollection?.items?.[3]?.media
                  ?.url ?? PLACEHOLDER_IMG
              }
              width={466}
              height={500}
            />
          ),
        },
      }) ??
      {},
    dataKeyFeatureCard:
      dataKeyFeatureCard.map((item: any) => {
        return {
          title:
            ['zh-Hans', 'zh-Hant'].indexOf(locale) >= 0
              ? titleLowerCase(item?.title || '')
              : item?.title ?? '',
          descriptionTop:
            item?.description && typeof item?.description === 'string'
              ? item?.description.replace(/\n/g, '<br>')
              : // documentToReactComponents(item?.description?.json, getOptions(item?.description)) ??
                '',
          descriptionBottom: '',
          image: item?.featuredImage?.media?.url ?? PLACEHOLDER_IMG,
          higher: true,
          imagePosition: item?.imagePosition.toLowerCase() ?? 'left',
          typeBorder: item?.imageFrameType?.toLowerCase() || '',
        };
      }) ?? [],
  };
};

const PADDING_COMPONENT: any = {
  '/games': {
    paddingTop: '0px',
    paddingBottom: {
      xs: '72px',
      lg: '140px',
    },
  },
  '/games/[slug]': {
    paddingTop: '0px',
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
};

const KeyFeatureContainerOrganisms: React.FC<IKeyFeatureContainerExt & any> = props => {
  const ComponentProps = useMemo(() => adapter(props), [props]);
  const {pathname} = GetRouter();
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? {}}>
      <KeyFeatureContainer {...ComponentProps} id={props?.id || ''} />
    </Box>
  );
};

export default KeyFeatureContainerOrganisms;
